module.exports = __webpack_public_path__ + "static/img/slogn-pt.bba1989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/slogn/slogn-pt.png
// module id = lcC1
// module chunks = 1